import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { useAuth } from './AuthProvider';

const ManualCreateUser = () => {
  const { currentUser, role } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userRole, setUserRole] = useState('inspector');
  const db = getFirestore();
  const auth = getAuth();

  const handleCreateUser = async () => {
    if (!email || !password) {
      alert('Email and password are required.');
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      await addDoc(collection(db, 'roles'), {
        uid: uid,
        role: userRole
      });

      alert('User created successfully');
      setEmail('');
      setPassword('');
      setUserRole('inspector');
    } catch (error) {
      console.error('Error creating user:', error);
      alert(error.message);
    }
  };

  if (!currentUser || role !== 'admin') {
    return <div>Access Denied</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Create New User</h1>
      <div className="flex flex-col gap-4 max-w-sm">
        <input
          type="email"
          placeholder="User Email"
          className="border p-2 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Temporary Password"
          className="border p-2 rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <select
          className="border p-2 rounded"
          value={userRole}
          onChange={(e) => setUserRole(e.target.value)}
        >
          <option value="inspector">Inspector</option>
          <option value="admin">Admin</option>
        </select>
        <button
          className="bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
          onClick={handleCreateUser}
        >
          Create User
        </button>
      </div>
    </div>
  );
};

export default ManualCreateUser;
